<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    #panel
    [class]="'agpr-datePicker-panel agpr-clickOutsideExcluded ' + (panelStyleClass || '')"
    [@overlayAnimation]="visible ? 'visible' : 'hidden'"
    (@overlayAnimation.start)="onAnimationStart($event)"
    (@overlayAnimation.done)="onAnimationDone($event)"
    (keydown)="onKeydown($event)"
    (keyup)="$event.stopPropagation()"
>
    <ng-content></ng-content>
</div>
